import React, { useEffect, useState } from "react";
import PropertyStepProgress from "../../components/common/PropertyStepProgress";
import BasicInfo from "./BasicInfo";
import MoreInfo from "./MoreInfo";
import CustomButton from "../../components/common/CustomButton";
import CustomHeading from "../../components/common/CustomHeading";
import Header from "../Header/Header";
import {
  showErrorToast,
  showSuccessToast,
} from "../../components/Constant/Notification";
import { ToastContainer } from "react-toastify";
import ProspectPropertyService from "../Service/ProspectPropertyService";
import { userUid } from "../../utils/storage";
import { useLocation, useNavigate } from "react-router-dom";

const PropertyInfoPage = () => {
  const location = useLocation();
  const { propertyId } = location.state || {
    propertyId: null,
  };
  const navigation = useNavigate();
  console.log("Rough Property ID:", propertyId);
  const [currentStep, setCurrentStep] = useState(1);

  const [propertyInfo, setPropertyInfo] = useState({
    name: "",
    propertyType: "",
    overAllArea: "",
    overallAreaType: {
      value: "sqft",
      label: "sqft",
    },
    propertySourcedBy: "",
    propertySellerName: "",
    propertySellerPhoneNumber: "",
    propertyNo: "",
    propertyVendorName: "",
    propertyVendorPhoneNumber: "",
    propertySaleType: "",
    location: "",
    geoLocation: "",
    address: "",
    landmark: "",
    locationLink: "",
    northDimension: "",
    southDimension: "",
    eastDimension: "",
    westDimension: "",
    roadFacing: "",
    villageName: "",
    sro: "",
    surveyNo: "",
    marketRatePerSqft: "",
    perCentGroundPrice: "",
    budget: "",
    lc: "",
    guideline: "",
    documentType: "",
    roi: "",
    days: "",
    ratePerSqft: "",
    overallMinimumBudget: "",
    overallMaxBudget: "",
    notes: "",
    imageAndVideos: [],
    driveLink: "",
    isRoughDraft: true,
    createdById: userUid || "",
    modifiedById: userUid || "",
    propertyBlueprints: [], // Added for MoreInfo
    propertyVideos: [], // Added for MoreInfo
  });

  // const handlePropertyInfoChange = (e) => {   const { name, value } = e.target;
  //   setPropertyInfo((prev) => ({     ...prev,     [name]: value,   })); };

  const handleArrayFieldChange = (fieldName, values) => {
    setPropertyInfo((prev) => ({
      ...prev,
      [fieldName]: values,
    }));
  };

  const fetchGetPropertyById = async (id) => {
    try {
      const response = await ProspectPropertyService.getProspectPropertyId(id);
      if (response.status === 200) {
        const data = response.data;
        setPropertyInfo({
          name: data.propertyName || "",
          // propertyType: data.propertyType   ? { value: data.propertyType, label:
          // data.propertyType }   : "",
          overAllArea: data.overallArea || "",
          overallAreaType: data.overallAreaType
            ? {
                value: data.overallAreaType,
                label: data.overallAreaType,
              }
            : "",
          propertySourcedBy: data.propertySourceBy || "",
          propertySellerName: data.sellerName || "",
          propertySellerPhoneNumber: data.sellerPhoneNumber || "",
          propertyNo: data.propertyNo || "",
          propertyVendorName: data.vendorName || "",
          propertyVendorPhoneNumber: data.vendorPhoneNumber || "",
          // propertySaleType: data.propertySaleType   ? { value: data.propertySaleType,
          // label: data.propertySaleType }   : "", location: data.locationId   ? { value:
          // data.locationId, label: data.locationId }   : "", geoLocation:
          // data.latitude && data.longitude     ? `${data.latitude}, ${data.longitude}`
          //   : "",
          address: data.address || "",
          landmark: data.landMark || "",
          locationLink: data.locationMapLink || "",
          northDimension: data.dimensions?.north || "",
          southDimension: data.dimensions?.south || "",
          eastDimension: data.dimensions?.east || "",
          westDimension: data.dimensions?.west || "",
          roadFacing: data.roadFacing || "",
          villageName: data.villageName || "",
          sro: data.gro || "",
          surveyNo: data.surveyNo || "",
          marketRatePerSqft: data.marketRatePerSqFt || "",
          perCentGroundPrice: data.perCentGroundPrice || "",
          budget: data.budget || "",
          lc: data.lc || "",
          guideline: data.guideline || "",
          documentType: data.documentType || "",
          roi: data.roi || "",
          days: data.days || "",
          ratePerSqft: data.ratePerSqft || "",
          overallMinimumBudget: data.overAllMinimumBudget || "",
          overallMaxBudget: data.overAllMaxBudget || "",
          notes: data.notes || "",
          imageAndVideos: data.imageAndVideos || [],
          driveLink: data.sketchLink || "",
          propertyBlueprints: data.propertyBlueprints || [],
          propertyVideos: data.propertyVideos || [""],
          isRoughDraft: data.isRoughDraft ?? true,
          createdById: data.createdById || userUid || "",
          modifiedById: userUid || "",
        });
      }
    } catch (error) {
      console.error("Error fetching property data:", error);
      showErrorToast("Failed to fetch property data.");
    }
  };

  useEffect(() => {
    if (propertyId) {
      fetchGetPropertyById(propertyId);
    }
  }, [propertyId]);

  const createPayload = () => {
    const [latitude, longitude] = propertyInfo.geoLocation
      ? propertyInfo.geoLocation
          .split(",")
          .map((coord) => parseFloat(coord.trim()))
      : [null, null];

    return {
      propertyType: propertyInfo.propertyType?.label || null,
      propertySaleType: propertyInfo.propertySaleType?.label || null,
      name: propertyInfo.name || null,
      propertyNo: Number(propertyInfo.propertyNo) || null,
      propertySourceBy: propertyInfo.propertySourcedBy?.value || null,
      sellerName: propertyInfo.propertySellerName || null,
      sellerPhoneNumber: propertyInfo.propertySellerPhoneNumber || null,
      locationId: propertyInfo.location?.value || null,
      latitude: Number(latitude),
      longitude: Number(longitude),
      address: propertyInfo.address || null,
      overallArea: parseFloat(propertyInfo.overAllArea) || null,
      overallAreaType: propertyInfo.overallAreaType?.value || null,
      dimensions: {
        north: propertyInfo.northDimension || null,
        south: propertyInfo.southDimension || null,
        east: propertyInfo.eastDimension || null,
        west: propertyInfo.westDimension || null,
      },
      roadFacing: propertyInfo.roadFacing || null,
      villageName: propertyInfo.villageName || null,
      landMark: propertyInfo.landmark || null,
      sro: propertyInfo.sro || null,
      surveyNo: propertyInfo.surveyNo || null,
      marketRatePerSqFt: parseFloat(propertyInfo.marketRatePerSqft) || null,
      ratePerSqft: parseFloat(propertyInfo.ratePerSqft) || null,
      perCentGroundPrice: parseFloat(propertyInfo.perCentGroundPrice) || null,
      budget: propertyInfo.budget || null,
      lc: propertyInfo.lc || null,
      guideline: parseFloat(propertyInfo.guideline) || null,
      documentType: propertyInfo.documentType || null,
      roi: parseFloat(propertyInfo.roi) || null,
      days: parseInt(propertyInfo.days) || null,
      locationMapLink: propertyInfo.locationLink || null,
      sketchLink: propertyInfo.driveLink || null,
      overAllMinimumBudget:
        parseFloat(propertyInfo.overallMinimumBudget) || null,
      overAllMaxBudget: parseFloat(propertyInfo.overallMaxBudget) || null,
      notes: propertyInfo.notes || null,
      imageAndVideos: propertyInfo.imageAndVideos || [],
      isRoughDraft: false,
      createdById: userUid || null,
      modifiedById: userUid || null,
    };
  };

  const handlePage = (step) => {
    setCurrentStep(step);
  };

  const steps = [
    {
      label: "Basic Info",
      action: () => handlePage(1),
    },
    {
      label: "More Info",
      action: () => handlePage(2),
    },
  ];

  const handleNextStep = () => {
    if (propertyInfo.name.trim() === "") {
      showErrorToast("Please enter the property name before proceeding.");
      return;
    }
    if (currentStep === steps.length) {
      setCurrentStep(1);
    } else {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleSaveOrUpdateProperty = async () => {
    const payload = createPayload();

    try {
      let response;
      if (propertyId) {
        response = await ProspectPropertyService.updateProspectProperty(
          propertyId,
          payload
        );
      } else {
        response = await ProspectPropertyService.createProspectProperty(
          payload
        );
      }
      if (response.status === 200 || response.status === 201) {
        showSuccessToast(
          propertyId
            ? "Property updated successfully!"
            : response.data?.message || "Property created successfully!"
        );
        setTimeout(() => {
          navigation(-1);
        }, 1500);
      }
    } catch (error) {
      console.error(
        `Error ${propertyId ? "updating" : "saving"} property:`,
        error
      );
      showErrorToast(
        error.response?.data?.message ||
          `Failed to ${propertyId ? "update" : "save"} property.`
      );
    }
  };

  const handlePropertyInfoChange = (e) => {
    const { name, value } = e.target;
    setPropertyInfo((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };
      if (name === "geoLocation") {
        const coords = value.split(",").map((c) => c.trim());
        if (coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
          updated.locationLink = `https://www.google.com/maps?q=${coords[0]},${coords[1]}`;
        } else {
          updated.locationLink = "";
        }
      }
      return updated;
    });
  };

  return (
    <div>
      <Header />
      <ToastContainer />
      <div className="pt-28 px-6 pb-10">
        <div className="flex items-center justify-between mb-5">
          <CustomHeading
            title={propertyInfo.name || "Property Name"}
            isIcon={true}
            textColor={"primary"}
          />
          <div className="flex gap-3">
            <CustomButton
              label={
                currentStep === steps.length
                  ? propertyId
                    ? "Update Property"
                    : "Save Property"
                  : "Next"
              }
              onClick={
                currentStep === steps.length
                  ? handleSaveOrUpdateProperty
                  : handleNextStep
              }
              customStyles="text-white bg-customGreen px-6 py-3 rounded-lg"
            />
          </div>
        </div>
        <div className="bg-white rounded-[10px] py-6 px-3">
          <PropertyStepProgress
            currentStep={currentStep}
            variant="create"
            steps={[
              {
                id: 1,
                label: "Basic Info",
                action: () => setCurrentStep(1),
              },
              {
                id: 2,
                label: "More Info",
                action: () => setCurrentStep(2),
              },
            ]}
          />{" "}
          {currentStep === 1 && (
            <div className="p-6">
              <BasicInfo
                propertyInfo={propertyInfo}
                setPropertyInfo={setPropertyInfo}
                handlePropertyInfoChange={handlePropertyInfoChange}
                handleArrayFieldChange={handleArrayFieldChange}
                isEdit={!!propertyId}
              />
            </div>
          )}
          {currentStep === 2 && (
            <div className="p-6">
              <MoreInfo
                propertyInfo={propertyInfo}
                setPropertyInfo={setPropertyInfo}
                handlePropertyInfoChange={handlePropertyInfoChange}
                handleArrayFieldChange={handleArrayFieldChange}
                isEdit={!!propertyId}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PropertyInfoPage;
